import type { UserData } from '@/__generated__/requests'
import { role as Roles } from '@/__generated__/requests'

export interface UserState {
  currentRole: Roles | null
  isInitialized: boolean
  user: UserData | null
}

export interface UserActions {
  resetUser: () => void
  setCurrentRole: (role: Roles | null) => void
  setIsInitialized: (isInitialized: boolean) => void
  setUser: (user: UserData | null) => void
}

export const isUserRole = (role: string): role is Roles => role in Roles
